export interface CookieArticle {
  titleKey: string;
  content: {
    mainTextKey?: string;
    subTitleKey?: string;
    bulletPointsKeys?: string[];
    additionalTextKeys?: string[];
    contactInfoKey?: string;
  }[];
}

export const cookiesData: CookieArticle[] = [
  {
    titleKey: "whatAreCookies.title",
    content: [
      {
        mainTextKey: "whatAreCookies.description",
      },
    ],
  },
  {
    titleKey: "ourPolicy.title",
    content: [
      {
        mainTextKey: "ourPolicy.description",
      },
    ],
  },
  {
    titleKey: "contact.title",
    content: [
      {
        mainTextKey: "contact.description",
      },
    ],
  },
];
